import React, { createContext, useEffect, useState } from 'react'

const themeApi = createContext({
  themMode: 'light',
  darkMode: () => { },
  lightMode: () => { }
});

export const ThemeProvider = ({ children }) => {
  const [themMode, setThemMode] = useState(() => {
  return localStorage.getItem('Mode') || 'light';
});

  const darkMode = () => {
    setThemMode('dark');
    document.documentElement.classList.add('dark')
  }

  const lightMode = () => {
    setThemMode('light');
    document.documentElement.classList.remove('dark')
  }

  useEffect(() => {
    const saved = localStorage.getItem('Mode');
    saved == 'dark' ? darkMode() : lightMode();

  }, [])

  useEffect(() => {
    localStorage.setItem('Mode', themMode)
  }, [themMode])


  return (
    <themeApi.Provider value={{ themMode, darkMode, lightMode }} >
      {children}
    </themeApi.Provider>
  )
}

export default themeApi
